export default __webpack_public_path__ + "static/media/dossier-logo-blue-h_4.b7c66732.png";